import { render, staticRenderFns } from "./PageOne.vue?vue&type=template&id=180a44f6&scoped=true&"
import script from "./PageOne.vue?vue&type=script&lang=ts&"
export * from "./PageOne.vue?vue&type=script&lang=ts&"
import style0 from "./PageOne.vue?vue&type=style&index=0&id=180a44f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a44f6",
  null
  
)

export default component.exports